import {
  INITIALIZE_CONFIG,
  HIDE_DOWNLOAD_APP_BANNER,
  HIDE_PERMISSIONS_BANNER,
  RESET_PERMISSIONS_BANNER,
  SAVE_LAST_SEARCH,
} from './constants';
import { LOCATION_CHANGE } from '../tracking/constants';
import {
  SUSCRIPTION_USER_HAS_DISALLOW_PUSH,
  SUSCRIPTION_USER_SUCCESS,
} from '../Notifications/constants';
import defaultState from '../state';

const configInitialState = defaultState.config;

export default (state = configInitialState, action) => {
  switch (action.type) {
    case INITIALIZE_CONFIG:
      return {
        ...state,
        countryCode: action.data.countryCode,
        verticalName: action.data.verticalName,
        verticalId: action.data.verticalId,
        locale: action.data.locale,
        routes: action.data.routes,
        env: action.data.env,
        vertical: action.data.vertical,
        client: action.data.client,
        isPushDisallow: action.data.isPushDisallow,
        isPushOpen: action.data.isPushOpen,
        showDownloadAppBanner: action.data.showDownloadAppBanner,
        showPermissionsBanner:
          !action.data.isPushDisallow && state.showPermissionsBannerCounter <= 3,
        showPermissionsBannerCounter: action.data.showPermissionsBannerCounter,
        lastSearch: action.data.lastSearch,
        verticalPath: action.data.verticalPath,
      };

    case HIDE_DOWNLOAD_APP_BANNER:
      return {
        ...state,
        showDownloadAppBanner: false,
      };

    case LOCATION_CHANGE:
      return {
        ...state,
        showPermissionsBanner: true,
      };

    case HIDE_PERMISSIONS_BANNER: {
      const count = action.isBlocked ? 100 : state.showPermissionsBannerCounter + 1;
      const isPushDisallow = count >= 3;
      return {
        ...state,
        showPermissionsBanner: false,
        isPushDisallow,
        showPermissionsBannerCounter: count,
      };
    }

    case RESET_PERMISSIONS_BANNER: {
      return {
        ...state,
        showPermissionsBanner: true,
        isPushDisallow: false,
        showPermissionsBannerCounter: 0,
      };
    }

    case SUSCRIPTION_USER_SUCCESS: {
      return {
        ...state,
        showPermissionsBanner: false,
        showPermissionsBannerCounter: 3,
      };
    }

    case SUSCRIPTION_USER_HAS_DISALLOW_PUSH:
      return {
        ...state,
        isPushDisallow: true,
      };

    case SAVE_LAST_SEARCH:
      return {
        ...state,
        lastSearch: action.payload || '',
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/Index/reducerConfig.js